import React from 'react';
import { Box } from '@mui/material';
import VideoPlayer from './VideoPlayer';
import InstructionTitle from './InstructionTitle';

/**
 * 歌曲视频组件（首页 / 结尾 Chant）
 * 使用统一 VideoPlayer，支持时间段截取
 */
function PhonicsSong({ data, title, titleAudio, titleCn, poster, instruction, instructionAudio, inlineCn = false }) {
  return (
    <Box sx={{ width: '100%', textAlign: 'center' }}>
      <InstructionTitle
        title={title}
        titleAudio={titleAudio}
        titleCn={titleCn}
        instruction={instruction}
        instructionAudio={instructionAudio}
        inlineCn={inlineCn}
      />
      <VideoPlayer
        src={data.src}
        poster={poster}
        startTime={data.startTime}
        endTime={data.endTime}
      />
    </Box>
  );
}

export default PhonicsSong;
